import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { StatsMutation } from "../common/home/Stats";
import {
  getTransactions,
  getOlderTransactions,
  getdetailTransaction,
} from "../../core/service/api_transaction";
import moment from "moment";
import { formatCurrency } from "../../config/global";
import { Transition } from "@headlessui/react";
import User from "../../core/models/user";
import { useAppSelector } from "../../core/feature/hooks";
import { useTranslation } from "react-i18next";

const ComponentTransactionDetailHistory = () => {
  const [transaction, setTransaction] = useState([]);
  const [detailTransaction, setDetailTransaction] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const year = new Date().getFullYear().toString();
  const month = String(Number(moment().format("MM")));
  const [transactionName, setTransactionName] = useState("");
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState<any>({});
  const user: User = useAppSelector((state) => state.user.user);
  let location: any = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    getDetail(
      location.state.month,
      location.state.year,
      location.state.transactionName
    );
  }, []);

  const getDetail = async (
    month: number,
    year: number,
    transactionName: String
  ) => {
    dispatch(setLoading(true));
    getdetailTransaction(month, year, transactionName)
      .then((res: any) => {
        console.log(res.data.content);
        dispatch(setLoading(false));
        setTransaction(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  return (
    <div className="font-montserrat bg-psp-primary pb-10">
      <StatsMutation />
      <div className="container-fluid">
        <div className="mx-auto w-full container md:-mt-30 -mt-20 p-4 px-5 relative justify-between items-left bg-white  shadow rounded-2xl">
          <h2>{t("TRANSACTION-DETAIL.title")}</h2>
          <div className="relative mt-5">
            {transaction.map((item: any, i: any) => {
              return (
                <div>
                  <div
                    key={i}
                    className="justify-end flex bg-red rounded-r-2xl rounded-l-xl  shadow mb-4 mx-auto"
                  >
                    <div className="flex ml-5 rounded-r-xl flex-row w-full bg-white">
                      <div className="mt-3 ml-4">
                        <p>
                          {moment(item.dateTime).format(
                            "MM / DD / YYYY, H:mm "
                          )}{" "}
                          <br />{" "}
                          <span className="font-bold">{item.callerName}</span>{" "}
                        </p>
                      </div>
                      <div className="mt-4">
                        <div className="flex absolute right-3 text-red">
                          <h4>{formatCurrency(item.debit)}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentTransactionDetailHistory;
